import { Reveal } from "./Reveal";
import { ArrowRight, MessageCircle } from "lucide-react";
import { scrollTo, WHATSAPP_LINK } from "@/lib/site";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="noise relative overflow-hidden bg-black py-28 md:py-40">
    <div className="pointer-events-none absolute inset-0">
      <div className="absolute left-1/2 top-1/2 h-[60vh] w-[80vw] -translate-x-1/2 -translate-y-1/2 rounded-full bg-royal/15 blur-[150px]" />
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:72px_72px] [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
    </div>
    <div className="relative mx-auto max-w-4xl px-6 text-center md:px-12">
      <Reveal>
        <h2 className="font-display text-4xl font-black uppercase leading-[1.02] tracking-tighter sm:text-5xl lg:text-7xl">
          Your business is ready.
          <br />
          <span className="text-gradient">Is your website?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-6 max-w-xl text-base text-zinc-400 md:text-lg">
          Build a professional digital presence with Falkeen Technologies.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <button
            onClick={() => scrollTo("#enquiry")}
            data-testid="final-cta-get-website-btn"
            className="group flex items-center gap-2 rounded-full bg-accent px-9 py-4 font-display text-xs font-bold uppercase tracking-[0.15em] text-ink transition-[background-color,box-shadow] duration-300 hover:bg-white hover:shadow-[0_0_45px_rgba(0,229,255,0.5)]"
          >
            Get Your Website Live
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp-btn"
            className="flex items-center gap-2 rounded-full border border-[#25D366]/40 bg-[#25D366]/10 px-9 py-4 font-display text-xs font-bold uppercase tracking-[0.15em] text-[#25D366] transition-[background-color] duration-300 hover:bg-[#25D366]/20"
          >
            <MessageCircle className="h-4 w-4" />
            Chat on WhatsApp
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.35}>
        <p className="mt-9 font-display text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-600 md:text-xs">
          Premium Websites • Professional Design • Affordable Pricing • Fast Launch
        </p>
      </Reveal>
    </div>
  </section>
);
